'use client';
var emailRegExp = /^\S+@\S+\.\S+$/g;

export { emailRegExp };
